import rawBrandConfig from './brand.config.json';

export interface BrandConfig {
  name: string;
  endorsedBy: string;
  palette: {
    petroleo: string;
    petroleoEscuro: string;
    coral: string;
    menta: string;
    offWhite: string;
    nevoa: string;
    sol: string;
    coralEscuro: string;
    branco: string;
  };
  support: {
    tintaSuave: string;
    erro: string;
    aviso: string;
    sucesso: string;
  };
  typography: {
    sans: string;
    serif: string;
    weights: {
      body: number;
      subtitle: number;
      title: number;
    };
  };
  shape: {
    sm: number;
    md: number;
    lg: number;
    seixo: number;
  };
  spacing: readonly number[];
  shadow: {
    soft: string;
  };
  usage: {
    surfaceRatio: Record<string, number>;
    primaryAction: {
      background: string;
      foreground: string;
    };
    digitalAccent: string;
    editorialFont: string;
    logoClearSpace: string;
  };
}

/** Machine-readable brand contract used by the theme and future AI-assisted updates. */
export const brandConfig: BrandConfig = rawBrandConfig;

export default brandConfig;